import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
	selector: 'app-human-recruit',
	templateUrl: './human-recruit.component.html',
	styleUrls: ['./human-recruit.component.scss'],
})
export class HumanRecruitComponent {
	isBrowser: boolean;

	constructor(@Inject(DOCUMENT) private document: Document, @Inject(PLATFORM_ID) private platformId) {}

	ngOnInit(): void {
		const canonical = this.document.querySelector('link[rel="canonical"]') as HTMLAnchorElement | null;
		if (canonical) canonical.href = 'https://www.kunyoutech.com.tw/humanRecruit';
	}
	open104Web() {
		window.open('https://www.104.com.tw/company/1a2x6blbgz', '_blank');
	}
}
